module.exports = __webpack_public_path__ + "static/media/code-shot.8e3063c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/code-shot.jpg
// module id = 96
// module chunks = 0